import React, { useEffect } from 'react';
import './SearchResults.css';
import { ResultTab } from './SearchTab';
import BrandsTab from './BrandsTab';
import PostsTab from './PostsTab';
import { SearchResponse } from '../../../types/searchType';
import { UserType } from '../../../types/userType';

interface SearchResultsProps {
  searchQuery: string;
  activeTab: ResultTab;
  setActiveTab: React.Dispatch<React.SetStateAction<ResultTab>>;
  searchResults: SearchResponse | null;
  isLoading: boolean;
  currentUser: UserType | null;
}

const SearchResults: React.FC<SearchResultsProps> = ({
  searchQuery,
  activeTab,
  setActiveTab,
  searchResults,
  isLoading,
  currentUser,
}) => {
  // Switch to brands tab if there are no posts but there are brands
  useEffect(() => {
    if (searchResults && !isLoading) {
      const hasPosts = searchResults.data.posts && searchResults.data.posts.length > 0;
      const hasBrands = searchResults.data.brands && searchResults.data.brands.length > 0;
      
      if (!hasPosts && hasBrands && activeTab === 'posts') {
        setActiveTab('brands');
      }
    }
  }, [searchResults, isLoading, activeTab, setActiveTab]);

  return (
    <div>
      <div className="tab-buttons">
        <button
          onClick={() => setActiveTab('posts')}
          className={activeTab === 'posts' ? 'active' : ''}
        >
          Posts
        </button>
        <button
          onClick={() => setActiveTab('brands')}
          className={activeTab === 'brands' ? 'active' : ''}
        >
          Brands
        </button>
      </div>
      {activeTab === 'posts' ? (
        <PostsTab 
          searchQuery={searchQuery} 
          posts={searchResults?.data?.posts || []} 
          currentUser={currentUser}
          isLoading={isLoading}
        />
      ) : (
        <BrandsTab 
          searchQuery={searchQuery} 
          brands={searchResults?.data?.brands || []} 
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

export default SearchResults;
